export const data = [
  {
    date: 'Mar 22',
    NOG: 0.5,
    Soda: 0.3,
    Textaco: 0.2,
    Trellis: 0.3,
  },
  {
    date: 'Mar 23',
    NOG: 0.56,
    Soda: 0.5,
    Textaco: 0.24,
    Trellis: 0.36,
  },
  {
    date: 'Mar 24',
    NOG: 0.54,
    Soda: 0.37,
    Textaco: 0.21,
    Trellis: 0.32,
  },
  {
    date: 'Mar 25',
    NOG: 0.52,
    Soda: 0.35,
    Textaco: 0.26,
    Trellis: 0.31,
  },
  {
    date: 'Mar 26',
    NOG: 0.52,
    Soda: 0.34,
    Textaco: 0.267,
    Trellis: 0.37,
  },
];
